export default {
  search (context, payload) {
    context.commit('search', payload)
  },
  artistBio (context, payload) {
    context.commit('artistBio', payload)
  },
  setSearchType (context, payload) {
    context.commit('searchType', payload)
  },
  getTracks (context, payload) {
    context.commit('trackList', payload)
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js